
//imports 
import React, { useState, useEffect, useCallback } from 'react'; // Import React and the useEffect and useState hooks

//styles
import './Countdown.css'; //


//COUNTDOWN COMPONENT 
// This component takes a targetDate prop and calculates the time left until that date is reached. It uses the useEffect and useState hooks to update the time left every second. The calculateTimeLeft function calculates the time left based on the target date and the current date. The timerComponents array is used to store the time left in days, hours, minutes, and seconds. The timerComponents array is then rendered in the JSX. If the time left is 0, the component displays "Time's up!". The Countdown component is exported as the default export. 
function Countdown({ targetDate }) {
  const calculateTimeLeft = useCallback(() => {
    const now = new Date();
    const difference = targetDate - now;

    let timeLeft = {};

    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        // seconds: Math.floor((difference / 1000) % 60),
      };
    }

    return timeLeft;
  }, [targetDate]);

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  // Update the time left every second 
  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearTimeout(timer);
  }, [timeLeft, calculateTimeLeft]);

  const timerComponents = [];

  // Loop through the timeLeft object and display the time left in days, hours, minutes, and seconds 
  Object.keys(timeLeft).forEach((interval) => {
    if (!timeLeft[interval]) {
      return;
    }

    timerComponents.push(
      <span key={interval}>
        {timeLeft[interval]} {interval}{" "}
      </span>
    );
  });

  // If the time left is 0, display "Time's up!" 
  return (
  <div className="countdown-container">
  
    <div className="countdown">
      {timerComponents.length ? timerComponents : <span>Time's up!</span>}
    </div>
  </div>
  );
}

export default Countdown;